"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _zip2 = _interopRequireDefault(require("lodash/zip"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var batteryId = _utils.screeners.PSS10;
var pssOptions = ["Never", "Almost Never", "Sometimes", "Fairly Often", "Very Often"];
var pssOptionsReversed = [].concat(pssOptions).reverse();
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "In the last week, how often have you",
  options: pssOptions
};
var pssQuestions = [// PSS - 10 questions
{
  prompt: "been upset because of something that happened unexpectedly?"
}, {
  prompt: "felt that you were unable to control the important things in your life?"
}, {
  prompt: "felt nervous and “stressed”?"
}, {
  prompt: "felt confident about your ability to handle your personal problems?",
  options: pssOptionsReversed,
  reversed: true
}, {
  prompt: "felt that things were going your way?",
  options: pssOptionsReversed,
  reversed: true
}, {
  prompt: "found that you could not cope with all the things that you had to do?"
}, {
  prompt: "been able to control irritations in your life?",
  options: pssOptionsReversed,
  reversed: true
}, {
  prompt: "felt that you were on top of things?",
  options: pssOptionsReversed,
  reversed: true
}, {
  prompt: "been angered because of things that were outside of your control?"
}, {
  prompt: "felt difficulties were piling up so high that you could not overcome them?"
}];
var questions = (0, _utils.wrapBattery)(pssQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var answers2 = (0, _zip2["default"])(questions, answers).map(function (qa) {
    return qa[0].reversed ? qa[1] : pssOptions.length - 1 - qa[1];
  });
  var score = Math.round((0, _sum2["default"])(answers2) * 2.5);
  return {
    PSS: score
  };
}